import { render, staticRenderFns } from "./login.page.vue?vue&type=template&id=3df8de2a&scoped=true&"
import script from "./login.page.vue?vue&type=script&lang=js&"
export * from "./login.page.vue?vue&type=script&lang=js&"
import style0 from "./login.page.vue?vue&type=style&index=0&id=3df8de2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df8de2a",
  null
  
)

export default component.exports